<template>
	<section>
		<div class>
			<div class="utab clearfix">
				<ul class="clearlist clearfix fl">
					<li :class="nowStatus==''?'active':''" @click="changeTab('')">
						<a href="javascript:;">所有订单</a>
					</li>
					<li :class="nowStatus=='0'?'active':''" @click="changeTab('0')">
						<a href="javascript:;">待审核</a>
					</li>
					<li :class="nowStatus==1?'active':''" @click="changeTab('1')">
						<a href="javascript:;">已审核</a>
					</li>
					<li :class="nowStatus==2?'active':''" @click="changeTab('2')">
						<a href="javascript:;">审核失败</a>
					</li>
					
          </li>
				</ul>
				<div class="usearch fr">
					
					<input type="text" placeholder="商品名称/订单号" class="layui-input" v-model="keyword" />
					<button type="primary" @click="search" class="layui-btn layui-btn-sm">搜索</button>
				</div>
			</div>
			<el-table :span-method="arraySpanMethod" :data="allOrder.data" ref="multipleTable" @selection-change="handleSelectionChange"
			 border style="width:98%; margin: 20px auto">
				<el-table-column type="selection" width="40"></el-table-column>
				<el-table-column label="订单信息" width="100">
					<template slot-scope="scope">
						<div class="text_l">
							<div>{{ scope.row.orderno }}</div>
							<br />
							<div>{{ scope.row.addtime }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="total" label="商品金额" width="80"></el-table-column>
				<el-table-column prop="discount" label="优惠" width="60"></el-table-column>
				<el-table-column prop="amount" label="实付款" width="120">
					<template slot-scope="scope">
						<div class="color-primary">￥{{scope.row.amount}}</div>
						<div class="color-primary">含运费￥{{scope.row.shipfee}}</div>
					</template>
				</el-table-column>
				<el-table-column label="商品信息" width="300" class-name="tablegoodsinfo">
					<template slot-scope="scope">
						<div class="hebin" v-for="(item_i,index_i) in scope.row.detail" :key="index_i" style="padding-right: 0;">
							<div class="clearfix cpinfo flex">
								<div class="img">
									<a :href="'product/'+item_i.productid+'.html'" target="_blank">
										<img :src="item_i.indexpic" />
									</a>
								</div>
								<div class style="flex:1; margin-left: 10px;">
									<div class="name ellipsis-2">{{item_i.title}}</div>
									<div class="info" style="font-size: 12px; color: #999;">{{item_i.specnames}}</div>
									<div class="cart-price" style="font-size: 12px;">数量：{{item_i.num}}</div>
								</div>
								<div class="color-primary" style="width:50px;text-align:center">{{item_i.unit}}</div>
								<div class="color-primary" style="width:70px;text-align:center">{{item_i.price}}</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="单位" width="50"></el-table-column>
				<el-table-column label="单价" width="70"></el-table-column>
				<el-table-column prop="statusText" label="订单状态" width="100"></el-table-column>
				<el-table-column prop="auditremark" label="审核备注" ></el-table-column>
				<el-table-column prop="amount3" label="操作" width="150">
					<template slot-scope="scope">
						<div style=" text-align: center">
							
							<el-button size="small" type="success" class="mb10" v-if="levelid>1&&scope.row.auditstatus==0"  @click="shenheOrder(scope.row.orderno)">审核订单</el-button>
							<el-button type="primary" size="small" class="mb10" @click="orderdetail(scope.row.orderno)" v-if="levelid<2&&scope.row.auditstatus==2">修改订单</el-button>
							<el-button type="primary" size="small" class="mb10" @click="viewdetail(scope.row.orderno)" v-if="levelid<2&&scope.row.auditstatus<2">查看订单</el-button>
							
							
							<!-- <el-button size="small" v-if="scope.row.auditstatus==1&&scope.row.draftid==0"  :type="scope.row.draftid>0?'default':'primary'" class="mb10" @click="submitOrder(scope.row.orderno)" >{{scope.row.draftid>0?"已生成正式单":"提交正式单"}}</el-button> -->
							
							<el-button size="small" v-if="scope.row.auditstatus==2&&levelid<2" type="primary" class="mb10 iconfont" @click="reshenghe(scope.row.orderno)" >重新提交审核</el-button>						
							<el-button size="small" type="danger" v-if="levelid<2"  @click="deteleOrder(scope.row.id)">删除订单</el-button>
							
						</div>
					</template>
				</el-table-column>
				
			</el-table>
			<div class="flex ju-ar">
				<el-button size="small" type="danger" class="iconfont" @click="selectedAll" style="margin:0 10px">
					<span v-if="multipleSelection.length<allOrder.data.length">全选</span>
					<span v-else>全不选</span>
				</el-button>
				<el-button size="small" type="danger" class="iconfont" @click="deteleOrder()" :disabled="multipleSelection.length==0"
				 style="margin:0 10px">删除所选订单</el-button>
				<el-pagination class="fenye" @size-change="handleSizeChange" @current-change="currentorder" :current-page="allOrder.current_page"
				 :page-sizes="[5, 10, 20, 50,100]" :page-size="allOrder.per_page" layout="total, sizes, prev, pager, next, jumper"
				 :total="allOrder.total"></el-pagination>
			</div>
			
			<div id="adrpop" class="adrpop" style="display: none;">
			  <el-form ref="form" label-width="80px">
			    <el-form-item label="审核结果">
			        <el-radio-group v-model="audit">
			          <el-radio label="1" >同意</el-radio>
			          <el-radio label="2">拒绝</el-radio>
			        </el-radio-group>
			      </el-form-item>
				   <el-form-item label="审核备注">
				      <el-input type="textarea" v-model="remark"></el-input>
				    </el-form-item>
					<el-form-item >
					   <el-button size="small" type="primary" @click="shcgorder" class="iconfont" >提交</el-button>
					 </el-form-item>
			   </el-form>
			</div>
			
		</div>
	</section>
</template>

<script>
	import eventBus from "../../static/eventBus.js";
	export default {
		name: "cgOrder",
		inject: ["reload"], //注入reload方法
		data() {
			return {
				
				audit:0,
				remark:'',
				shorderno:'',
				userInfo: {},
				guid: sessionStorage.guid,
				indexData: {},
				nowStatus: "",
				keyword: "",
				multipleSelection: [],
				orderstatus: [{
						0: "待审核"
					},
					{
						1: "已审核"
					},
					{
						2: "审核失败"
					}
					
				],
				page: 1,
				pagesize: 5,
				allOrder: {
					data: []
				}, //全部订单的数据
				orderno: "",
				goodsKeyWord: ""
			};
		},
		props: {
			now_status: {
				type: String,
				default: ""
			},
			levelid: {
				type: [String, Number]
			}
		},
		watch: {
			orderno(newValue, oldValue) {
				eventBus.$emit("my-event", {
					orderno: newValue,
					orderType: 'cgorder'
				});
			}
		},
		methods: {
			shcgorder:async function(){
				console.log(this.audit,this.remark)
				
				layer.closeAll(); 
				this.$confirm("您确认要提交审核结果吗?", "提示", {
						type: "warning"
					})
					.then(async () => {						
						let res = await this.$fetch("member/orderdraft", {
							body: {
								act:'audit',
								orderno:this.shorderno,
								status:this.audit,
								remark:this.remark
							}
						});
						if (res) {
							this.$message.success("审核成功");
							this.getOrderList();
							eventBus.$emit('changeshnum')
						}
					})
			},
			shenheOrder:function(orderno){
				let that = this;
				this.shorderno=orderno
				layui.use(["form", "layer"], function() {
				  var form = layui.form;
				  var layer = layui.layer;
				  
				  that.addressModal = layer.open({
				    title: "审核草稿订单",
				    area: "800px",
				    type: 1,
				    content: $("#adrpop"),
					cancel: function(){ 
					  that.remark=''
					  that.audit=0
					  
					}    
				  });
				 
				});
			},
			
			
			
			currentorder(e) {
				this.page = e;
				this.getOrderList();
			},
			handleSizeChange(e) {
				this.pagesize = e;
				this.page = 1;
				this.getOrderList();
			},
			arraySpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 5) {
					return [1, 3];
				} else if (columnIndex === 6) {
					return [0, 0];
				} else if (columnIndex === 7) {
					return [0, 0];
				} 
			},
			// 封装获取数据的方法
			async getOrderList() {
				// alert(this.now_status)
				let res = await this.$fetch("member/orderdraft", {
					body: {
						act:'list',
						page: this.page,
						pagesize: this.pagesize,
						status: this.nowStatus,
						keyword: this.keyword
					}
				});
				for (let i = 0; i < res.data.length; i++) {
					let text = "";
					if (res.data[i].auditstatus == 0) {
						text = "待审核";
					} else if (res.data[i].auditstatus == 1) {
						text = "已审核";
					} else if (res.data[i].auditstatus == 2) {
						text = "审核失败";
					} 

					res.data[i]["statusText"] = text;
					for (let j = 0; j < res.data[i].detail.length; j++) {
						if (res.data[i].detail[j].iscomment == 0) {
							res.data[i]["needComment"] = true;
							break;
						}
					}
				}
				res.per_page = parseInt(res.per_page);
				this.allOrder = res;
			},
			async reshenghe(orderno) {
				this.$confirm("您确认要重新提交审核吗?", "提示", {
						type: "warning"
					})
					.then(async () => {						
						let res = await this.$fetch("member/orderdraft", {
							body: {
								act:'submitaudit',
								orderno:orderno
							}
						});
						if (res) {
							this.$message.success("提交成功");
							this.getOrderList();
						}
					})
			},
			async submitOrder(orderno) {				
				this.$confirm("您确认要提交正式订单吗?", "提示", {
						type: "warning"
					})
					.then(async () => {						
						let res = await this.$fetch("member/orderdraft", {
							body: {
								act:'createorder',
								orderno:orderno
							}
						});
						if (res) {
							this.$message.success("提交成功");
							this.getOrderList();
							this.goPay(orderno,1)
							eventBus.$emit('changeshnum')
						}
					})
			},
			async deteleOrder(ids) {
				
				this.$confirm("您确认要删除吗?", "提示", {
						type: "warning"
					})
					.then(async () => {
						if (!ids) {
							ids = this.multipleSelection.map(item => {
								return item.id;
							});

							ids = ids.join(",");
						}
						//console.log("ids",ids); return;
						let res = await this.$fetch("member/orderdraft", {
							body: {
								act:'delete',
								ids:ids
							}
						});
						if (res) {
							this.$message.success("删除成功");
							this.getOrderList();
							eventBus.$emit('changeshnum')
						}
					})
			},
			toReturnOrder(item) {
				console.log(item)
				this.$router.push(`usercenter?type=1-4&orderno=${item.orderno}`)
				this.reload(); //直接调用
			},
			currentPageorder(e) {
				this.page = e;
				this.getOrderList();
			},
			orderdetail(orderno) {
				this.orderno = orderno;
				eventBus.$emit('editorder',{isedit:true})
			},
			viewdetail(orderno) {
				this.orderno = orderno;
				eventBus.$emit('editorder',{isedit:false})
			},

			// 去支付
			goPay(orderno, paymethod) {
				this.$router.push({
					path: `/jieguo?orderno=${orderno}&paymethod=${paymethod}`
				});
			},
			
			// 搜索
			search() {
				this.getOrderList();
			},
			// 改变tab
			changeTab(type) {
				console.log(type);
				this.nowStatus = type;
				console.log(this.now_status);
				this.getOrderList();
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			
			// 全选和全部不选
			selectedAll() {
				if (this.multipleSelection.length < this.allOrder.data.length) {
					this.allOrder.data.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			
			keyupSubmit() {
				document.onkeydown = e => {
					let _key = window.event.keyCode;
					if (_key == 13) {
						this.search();
					}
				};
			}
		},
		created() {
			
			this.keyupSubmit();
		},
		async mounted() {
			
			this.nowStatus = this.now_status;
			await this.getOrderList();
			// this.fenye();
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
	.br {
		display: inline-block;
	}

	.exportantOrder {
		margin-right: 30px;
	}

	.img {
		width: 80px;
		height: 80px;
		margin-bottom: 10px;

		a {
			display: inline-block;
			width: 100%;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.cont {
		// width: 150px;
		margin: 0 10px;
	}

	.cart-price {
		width: 100px;
	}
</style>



// WEBPACK FOOTER //
// src/components/cgorder.vue